module.exports = __webpack_public_path__ + "static/media/Inspecttheinterior.af8ef31e.svg";